import { Box, Grid, Typography } from '@mui/material'

import Anchor from '@ecm/ui/element/Anchor'
import CloudflareImage from '@ecm/ui/element/CloudflareImage'
import Color from '@ecm/ui/element/Color'
import MainContainer from '@ecm/ui/element/MainContainer'
import Metric from '@ecm/ui/element/Metric'
import DefaultLayout from '@ecm/ui/layout/Default'

import checkIcon from '/public/images/icon/check.svg'
import locationPinIcon from '/public/images/icon/location-pin.svg'
import mailIcon from '/public/images/icon/mail.svg'
import paperShreddingIcon from '/public/images/icon/paper-shredding.svg'
import newMailIllustration from '/public/images/illustration/new-mail.svg'
import secureFacilityIllustration from '/public/images/illustration/secure-facility.svg'
import teamIllustration from '/public/images/illustration/team.png'

export const AboutUsPage = () => (
  <DefaultLayout
    finalCtaHeader="Join our team today"
    finalCta="Find a career"
    primaryHref="/company/careers"
    seoPage="company/about"
  >
    <Box bgcolor={Color.smoke.normal} paddingY={{ md: '4em', sm: '2em' }}>
      <MainContainer>
        <Grid
          justifyItems="center"
          alignItems="center"
          display="grid"
          gridTemplateColumns={{ md: '1fr 1fr' }}
          bgcolor={Color.smoke.normal}
        >
          <Grid
            container
            direction="column"
            gridColumn="1"
            justifyContent="space-between"
            maxWidth="30em"
          >
            <Typography variant="h2" component="h1">
              About Us
            </Typography>
            <Typography variant="p2">
              We help you manage your postal mail online, so you have the freedom to focus on more
              important things.
            </Typography>
            <Typography variant="p2">
              Since 2004, Earth Class Mail has helped thousands of businesses and individuals,
              including companies like Zapier, Reddit, and Lyft, access and control their postal
              mail online, from anywhere.
            </Typography>
          </Grid>

          <Box width="80%">
            <CloudflareImage src={teamIllustration} />
          </Box>
        </Grid>
      </MainContainer>
    </Box>

    <MainContainer>
      <Grid
        justifyItems="center"
        alignItems="center"
        display="grid"
        gridTemplateColumns={{ md: '0.5fr 0.5fr' }}
        borderBottom={`1px solid ${Color.smoke.normal}`}
        paddingY={{ md: '4em', sm: '2em' }}
      >
        <Box width="90%">
          <CloudflareImage src={newMailIllustration} />
        </Box>
        <Grid container direction="column" justifyContent="space-between" maxWidth="32em">
          <Typography variant="h4" component="h2">
            You shouldn't have to go to your mailbox to get your mail
          </Typography>
          <Typography variant="p2">
            Dealing with paper mail can be overwhelming, and you have more important things to do.
          </Typography>
        </Grid>
      </Grid>

      <Grid
        justifyItems="center"
        alignItems="center"
        display="grid"
        gridTemplateColumns={{ md: '0.5fr 0.5fr' }}
        paddingY={{ md: '4em', sm: '2em' }}
      >
        <Grid container direction="column" justifyContent="space-between" maxWidth="32em">
          <Typography variant="h4" component="h2">
            How We Help
          </Typography>
          <Typography variant="p2">
            Businesses and individuals today embrace the idea of going paperless — bringing
            efficiency to their operations and everyday lives.
          </Typography>
          <Typography variant="p2">
            By taking the hassle and frustration out of postal mail, we help our customers spend
            less time on administrative tasks to focus on what really matters.
          </Typography>
        </Grid>
        <Box width="90%">
          <CloudflareImage src={secureFacilityIllustration} />
        </Box>
      </Grid>
      <Grid
        display="grid"
        gap="0.5em"
        gridTemplateColumns={{ md: 'repeat(4, 1fr)', sm: 'repeat(2, 1fr)' }}
        paddingY={{ md: '4em', sm: '2em' }}
      >
        <Metric
          value="80+"
          label={<b>virtual addresses</b>}
          icon={locationPinIcon}
          bgColor={Color.smoke.normal}
        />
        <Metric
          value="18"
          unit="M"
          label={<b>pieces of mail scanned</b>}
          icon={mailIcon}
          bgColor={Color.smoke.normal}
        />
        <Metric
          value="$2.4"
          unit="B"
          label={<b>checks deposited</b>}
          icon={checkIcon}
          bgColor={Color.smoke.normal}
        />
        <Metric
          value="228.8"
          label={<b>tons of paper recycled a year</b>}
          icon={paperShreddingIcon}
          bgColor={Color.smoke.normal}
        />
      </Grid>

      <Box paddingY={{ md: '4em', sm: '2em' }}>
        <Typography variant="h4" component="h2" textAlign="center">
          Resources
        </Typography>
        <Grid justifyItems="center" display="grid" gridTemplateColumns={{ md: '1fr 1fr' }}>
          <Grid container direction="column" justifyContent="space-between" alignItems="center">
            <CloudflareImage src="/images/icon/logomark.svg" width={96} height={96} />
            <Typography variant="h5" component="h3">
              Press Kit
            </Typography>
            <Typography variant="p2" my="0.5em">
              Grab official Earth Class Mail logos and photos
            </Typography>
            <Anchor
              caret
              external
              href="https://www.dropbox.com/sh/zriol04osl1zk64/AAChmamSGTqVOBB0Aw33-7_Za?dl=0"
            >
              Download Press Kit
            </Anchor>
          </Grid>

          <Grid container direction="column" justifyContent="space-between" alignItems="center">
            <CloudflareImage src="/images/icon/document.svg" width={96} height={96} />
            <Typography variant="h5" component="h3">
              Blog
            </Typography>
            <Typography variant="p2" my="0.5em">
              Catch up on the latest company news
            </Typography>
            <Anchor href="/blog" caret>
              Read the latest news
            </Anchor>
          </Grid>
        </Grid>
      </Box>
    </MainContainer>
  </DefaultLayout>
)

export default AboutUsPage
